"use strict";

import { optimumFrictionConstants } from "../_constants/optimumFriction.constants";

export const optimumFrictionPreviewTrainingImportRequest = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_REQUEST,
     payload,
});

export const optimumFrictionPreviewTrainingImportComplete = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_COMPLETE,
     payload,
});

export const optimumFrictionCommitTrainingImportRequest = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_REQUEST,
     payload,
});

export const optimumFrictionCommitTrainingImportComplete = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_COMPLETE,
     payload,
});

export const optimumFrictionClearTrainingImport = () => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_CLEAR_TRAINING_IMPORT,
});

export const optimumFrictionGetTrainingImportsRequest = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_REQUEST,
     payload,
});

export const optimumFrictionGetTrainingImportsComplete = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_COMPLETE,
     payload,
});

export const optimumFrictionGetReportRequest = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_REQUEST,
     payload,
});

export const optimumFrictionGetReportComplete = (payload) => ({
     type: optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_COMPLETE,
     payload,
});
